// extracted by mini-css-extract-plugin
export default {"APPROVING":"AgreementsStatus_APPROVING__QBRbK"};